/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Divider, Box, Grid, Paper, IconButton } from '@material-ui/core';
import { useNavigate, useLocation } from '@reach/router';
const { selectDesktop } = Slices.appSlice;
import { navList } from './RouteConstants';
import MenuRouteCard from './MenuRouteCard';
import ViewProfileCard from './ViewProfileCard';
import EditProfileCard from './EditProfileCard';
import css from './index.module.scss';
import ClassNames from 'classnames';
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';

function Profile() {
  const profile = useSelector((state) => state.profile);
  const [editProfile, setEditProfile] = React.useState(false);
  const [addLocalNumber, setAddLocalNumber] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);

  const setEditProfileStatus = () => {
    setEditProfile(!editProfile);
  };

  useEffect(() => {
    location.state?.fromPage === 'checkout' && setEditProfile(true);
  }, [location.state.fromPage]);

  useEffect(() => {
    if (profile.status === 'succeeded') {
      setAddLocalNumber(
        profile?.data?.data?.length && profile?.data?.data[0].phnNo !== '' ? false : true
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.status]);

  const addNewNumber = () => {
    navigate(`/${intl.locale}/addNumber`, {
      state: { oldLocation: location?.state?.oldLocation || location },
    });
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <Grid className={!isDesktop ? css.darkBackground : css.lightBackground}>
      {!isDesktop ? (
        <Grid className={css.backHeader}>
          <IconButton onClick={handleClose}>{'<'}</IconButton>
          <span className={css.mobileHeaderTitle}>
            <FormattedMessage id="profile_myprofile" defaultMessage={'My Profile'} />
          </span>
        </Grid>
      ) : (
        <div className={css.header}>
          <div className={css.mainHeading}>
            <FormattedMessage id="profile_myprofile" defaultMessage="My Profile" />
          </div>
          <IconButton>
            <IoMdClose className={css.closeIcon} onClick={handleClose} />
          </IconButton>
        </div>
      )}

      <div className={css.main}>
        <Box className={css.profileBox}>
          <Grid>
            <Paper square className={css.transparentBackground}>
              {!editProfile ? (
                <Grid className={css.profileInfo}>
                  <ViewProfileCard profile={profile} />
                  {!addLocalNumber && (
                    <>
                      <Divider />
                      <Grid className={css.buttonGridArea}>
                        <>
                          <Button className={css.linkButton} onClick={setEditProfileStatus}>
                            <FormattedMessage
                              id="profile_editprofile"
                              defaultMessage="Edit Profile"
                            />
                          </Button>
                        </>
                      </Grid>
                    </>
                  )}
                  {addLocalNumber && (
                    <Grid className={ClassNames(css.buttonGridArea, css.newNumber)}>
                      <>
                        <Button className={css.linkButton} onClick={setEditProfileStatus}>
                          <FormattedMessage
                            id="profile_editprofile"
                            defaultMessage="Edit Profile"
                          />
                        </Button>
                        <Button className={css.linkButton} onClick={addNewNumber}>
                          <FormattedMessage
                            id="profile_addnewnumber"
                            defaultMessage="Add New Number"
                          />
                        </Button>
                      </>
                    </Grid>
                  )}
                </Grid>
              ) : (
                <div className={css.profileEditText}>
                  {/* <FormattedMessage id="edit_profile_text" defaultMessage="Profile text" /> */}
                  <Grid className={css.redLine} />
                  <EditProfileCard
                    profile={profile}
                    isEditMode={setEditProfileStatus}
                    page="editProfile"
                  />
                </div>
              )}
            </Paper>
          </Grid>
        </Box>
        {editProfile ? (
          ''
        ) : (
          <Grid>
            <MenuRouteCard navList={navList.profileMenu} />
          </Grid>
        )}
      </div>
    </Grid>
  );
}

export default Profile;
